<script setup lang="ts">
import CheckboxComponent from "@/stories/form/Checkbox/CheckboxComponent.vue";

interface Props {
  label: string;
  description?: string;
  modelValue?: boolean;
  disabled?: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits(["update:modelValue"]);

const handleToggle = () => {
  emit("update:modelValue", !props.modelValue);
};
</script>

<template>
  <button
    class="flex justify-between gap-3 items-center cursor-pointer select-none text-left focus-visible-strong rounded"
    role="checkbox"
    :disabled="disabled"
    :aria-checked="modelValue"
    :aria-disabled="disabled"
    :aria-label="description ? `${label}. ${description}` : label"
    @click="handleToggle"
  >
    <CheckboxComponent
      :checked="modelValue"
      :disabled="disabled"
      :tabindex="-1"
      aria-hidden="true"
      @click.stop="handleToggle"
    />
    <div class="grow" :class="{ 'opacity-60': disabled }">
      <div class="h200">{{ label }}</div>
      <div v-if="description" class="b200">{{ description }}</div>
    </div>
  </button>
</template>
